// extracted by mini-css-extract-plugin
module.exports = {"row":"super-grops_row__a1fqn"};